module.exports = __webpack_public_path__ + "images/825123ddfbe8b7524f69fbf7632217d5.png";